import { Tag, Avatar as AvatarRoot } from "@chakra-ui/react";

export default function Avatar({ name, src, size = 'md' }){
    return(
    <Tag.Root key={size} size={size} rounded="full">
        <Tag.StartElement>
          <AvatarRoot.Root size="full">
            <AvatarRoot.Image src={src} />
            <AvatarRoot.Fallback name={name} />
          </AvatarRoot.Root>
        </Tag.StartElement>
        <Tag.Label>{name}</Tag.Label>
    </Tag.Root>
    )
}